<main *ngIf="sharedService.selectedDevice" fxLayout="column" fxLayoutAlign="flex-start center">

  <div *ngIf="sharedService.devicesArray.length > 1">
    <!--   <button class="card-button" mat-flat-button color="accent" (click)="applyToAllDeviceFromGroup()">{{'applyToAll' | translation}}</button>-->
    <button class="card-button" mat-flat-button color="accent" (click)="applyToSpecifiqDevice()">{{'applyToDevice' | translation}}</button>

  </div>
  <section id="main-section">
    <p class="main-title">{{'globalParameters' | translation}}</p>
    <p class="main-subtitle">{{'parameterDescription' | translation}}</p>

    <div class="card" fxLayout="row" fxLayoutAlign="flex-start flex-start">


      <section class="card-section" fxLayout="column" fxLayoutAlign="flex-start flex-start">
        <p class="card-title">{{'background' | translation}}</p>
        <p class="card-subtitle">{{'backgroundDescription' | translation}} </p>


        <div class="backgroundTypeSelect" *ngIf="sharedService.checkAppVersion('1.20.0', 'media')">
          <p class="card-title">{{'homeBackgroundType' | translation}}</p>
          <p class="card-subtitle">Sélection de la configuration de l'écran de veille</p>

          <mat-form-field>
            <mat-select [(ngModel)]="sharedService.configForm.homeBackgroundType" (ngModelChange)="changeValue();   initTable();">
              <mat-option value="full">{{'fullHomeBackground' |translation}}</mat-option>
              <mat-option value="split-twothird">{{'splitTwothirdHomeBackground' | translation}}</mat-option>
              <mat-option value="split-three">{{'splitThreeHomeBackground' |translation}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- FOND D'ECRAN THUMBNAIL -->
        <!-- MULTI DESIGN BACKGROUND MANAGER -->
        <ng-container *ngIf="sharedService.checkAppVersion('1.20.0', 'media') && sharedService.configForm.homeBackgroundType != 'full'; else defaultBackgroundManager">


          <p class="card-subtitle">Liste des arrières-plan enregistrés</p>
          <div class="thumbnail-wrapper">

            <div matRipple
                 [matMenuTriggerFor]="menuBackgroundConfig"
                 *ngFor="let img of backgroundItems; let i = index"
                 class="thumbnail-content"
                 fxLayout="column" fxLayoutAlign="space-around center">
              <img *ngIf="(img | mapFileName) == 'jpg' || (img | mapFileName) == 'png'"
                   class="image-thumbnail thumbnail"
                   [src]="img" poster="" />
              <!-- IF IS A VIDEO -->
              <div fxLayout="column" fxLayoutAlign="center center" class="video-thumbnail thumbnail"
                   *ngIf="(img | mapFileName) == 'video'">
                <mat-icon>video_library</mat-icon>

              </div>

              <!-- TITLE -->
              <p class="overflow-ellipsis thumbnail-label"
                 [style.font-size.px]="stylingService.getFontSize('small')"
                 *ngIf="sharedService.urlToNameArray[i] != undefined">{{getNameFromUrl(img)}}</p>


              <mat-menu #menuBackgroundConfig="matMenu">
                <button mat-menu-item (click)="setBackgroundInCategory('atop', img)">{{'top' | translation }}</button>
                <button *ngIf="sharedService.configForm.homeBackgroundType == 'split-three'" mat-menu-item (click)="setBackgroundInCategory('middle', img)">{{'middle' | translation }}</button>
                <button mat-menu-item (click)="setBackgroundInCategory('zbottom', img)">{{'bottom' | translation }}</button>
                <button mat-menu-item (click)="removeBackground(img)"> {{'delete' | translation }}</button>
              </mat-menu>

            </div>


              <ng-container *ngFor="let item of sharedService.configForm.listBackgroundDisplayConfig | keyvalue; let index = index">
                <ng-container *ngIf="isVisibleConfig(item.key)">
                  <app-split-background (splitBackgroundRes)="updateSplitConfig($event)" (changeSplitBackgroundPosition)="updatePositionBackground($event)" [backgroundListElementData]="item"></app-split-background>

                </ng-container>
              </ng-container>


          </div>


        </ng-container>


        <!-- DEFAULT BACKGROUND MANAGER -->
        <ng-template #defaultBackgroundManager>

          <div class="thumbnail-wrapper" #rowLayout cdkDropListGroup>
            <div fxLayout="row"
                 *ngFor="let itemsRow of getItemsTable(rowLayout)"
                 cdkDropList
                 cdkDropListOrientation="horizontal"
                 [cdkDropListData]="itemsRow"
                 (cdkDropListDropped)="drop($event)">


              <div matRipple
                   cdkDrag
                   [matMenuTriggerFor]="menu"
                   *ngFor="let img of itemsRow; let i = index"
                   class="thumbnail-content"
                   fxLayout="column" fxLayoutAlign="space-around center">

                <!-- <button class="button-icon" mat-button [matMenuTriggerFor]="menu">
                  <mat-icon>settings</mat-icon>
                </button> -->
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="setActiveBackground(img)">{{'activate' | translation }}</button>
                  <button mat-menu-item (click)="removeBackground(img)"> {{'delete' | translation }}</button>
                </mat-menu>

                <span class="badge" *ngIf="img == sharedService.configForm.backgroundURL" matBadge="✔" matBadgeOverlap="true"></span>

                <!-- <i *ngIf="img == sharedService.configForm.backgroundURL " class="material-icons" id="activeBackground">
                  done
                </i> -->
                <!-- IF IS AN IMAGE -->
                <img *ngIf="(img | mapFileName) == 'jpg' || (img | mapFileName) == 'png'"
                     class="image-thumbnail thumbnail"
                     [src]="img" poster="" />
                <!-- IF IS A VIDEO -->
                <div fxLayout="column" fxLayoutAlign="center center" class="video-thumbnail thumbnail"
                     *ngIf="(img | mapFileName) == 'video'">
                  <mat-icon>video_library</mat-icon>

                </div>

                <!-- TITLE -->
                <p class="overflow-ellipsis thumbnail-label"
                   [style.font-size.px]="stylingService.getFontSize('small')"
                   *ngIf="sharedService.urlToNameArray[i] != undefined">{{getNameFromUrl(img)}}</p>


              </div>

            </div>


          </div>
          <section class="card-section" fxLayout="column" fxLayoutAlign="flex-start flex-start">
            <div class="form-group" id="galleryEnable">
              <mat-slide-toggle color="accent" type="checkbox" (change)="changeValue()" name="galleryEnable"
                                [(ngModel)]="sharedService.configForm.galleryEnable">
                {{'activateSlideshow' | translation}}
              </mat-slide-toggle>
            </div>

            <div *ngIf="sharedService.configForm.galleryEnable">
              <mat-form-field autocomplete="off">
                <input matInput placeholder="Délai de transition (en sec)" (change)="changeValue()" type="number"
                       [(ngModel)]="sharedService.configForm.timerSlideshow" matInputclass="form-control" id="timerSlideshow"
                       name="timerSlideshow">
              </mat-form-field>
            </div>

          </section>
        </ng-template>
        <button class="card-button" mat-flat-button color="primary" (click)="onUploadImage()">
          {{ 'importBackground' | translation }}
        </button>

      </section>


      <div class="divider"> </div>
      <section class="card-section">
        <p class="card-title">{{'welcomeText' | translation}}</p>
        <p class="card-subtitle">{{'screensaverText' | translation}}</p>
        <p class="card-data">{{sharedService.configForm.startText}}</p>
        <button class="card-button" mat-flat-button color="primary" (click)="showModal('welcomeText')">
          {{'changeText' | translation}}
        </button>
        <!-- <mat-divider [inset]="true"></mat-divider> -->


        <section class="card-section">
          <div>
            <p class="card-title">{{'activateText' | translation}}</p>
            <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
            <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.activeText" (ngModelChange)="changeValue()">
            </mat-slide-toggle>
            <!-- <mat-divider [inset]="true"></mat-divider> -->
          </div>
          <div *ngIf="sharedService.checkAppVersion(null, 'media')">
            <p class="card-title">{{'titlePosition' | translation}} (Média 1.18.9+)</p>
            <mat-form-field>
              <mat-label>{{'titlePosition' | translation}}</mat-label>
              <mat-select [(ngModel)]="sharedService.configForm.titlePosition" (ngModelChange)="changeValue()">
                <mat-option value="high">{{'high' |translation}}</mat-option>
                <mat-option value="center">{{'center' |translation}}</mat-option>
                <mat-option value="low">{{'low' |translation}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>

        <section class="card-section">
          <p class="card-title">{{'activateTextBackground' | translation}}</p>
          <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
          <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.activeTextBackground" (ngModelChange)="changeValue()">
          </mat-slide-toggle>
          <!-- <mat-divider [inset]="true"></mat-divider> -->
        </section>

        <section class="card-section">
          <p class="card-title">{{ 'welcomeTextColor' | translation}}</p>
          <p class="card-subtitle"></p>

          <div class="color-thumb" [style.background]='sharedService.configForm.welcomeTextColor'></div>
          <button class="card-button" mat-flat-button color="primary" (click)="showModal('textColor', 'Couleur d\'affichage du texte de bienvenue')">
            {{'changeColor' | translation}}
          </button>
          <!-- <mat-divider [inset]="true"></mat-divider> -->
        </section>

        <section class="card-section">
          <p class="card-title">{{ 'textBackgroundColor' | translation}}</p>
          <p class="card-subtitle"></p>

          <div class="color-thumb" [style.background]='sharedService.configForm.backgroundTextColor'></div>
          <button class="card-button" mat-flat-button color="primary" (click)="showModal('textColor', 'Couleur d\'affichage de l\'arriere-plan')">
            {{'changeColor' | translation}}
          </button>
          <!-- <mat-divider [inset]="true"></mat-divider> -->
        </section>
        <section class="card-section" *ngIf="sharedService.checkAppVersion(null, 'media')">
          <p class="card-title">{{ 'colorBackgroundDisplay' | translation}} (Média 1.18.11+)</p>
          <p class="card-subtitle"></p>

          <div class="color-thumb" [style.background]='sharedService.configForm.backgroundColor || "black"'></div>
          <button class="card-button" mat-flat-button color="primary" (click)="showModal('backgroundColor', 'Couleur d\'affichage de l\'arriere-plan')">
            {{'changeColor' | translation}}
          </button>
          <!-- <mat-divider [inset]="true"></mat-divider> -->
        </section>


        <section *ngIf="mediaActive || lotteryActive" class="card-section">
          <p class="card-title">{{'activateAnimation' | translation}}</p>
          <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
          <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.activeAnim" (ngModelChange)="changeValue()">
          </mat-slide-toggle>
          <!-- <mat-divider [inset]="true"></mat-divider> -->
        </section>


        <ng-container *ngIf="isDev || firebaseService.user.uid == 'NUzuxiTO5nbnPZpl8p9WkLeykDJ2'">
          <div class="divider"> </div>
          <section class="card-section">
            <div>


              <p class="card-title">{{'activateNewsBanner' | translation}}</p>
              <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
              <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.activeNewsBanner" (ngModelChange)="changeValue()">
              </mat-slide-toggle>
            </div>
            <div>

              <p class="card-title">{{ 'newsBannerTextColor' | translation}}</p>
              <p class="card-subtitle"></p>
              <div class="color-thumb" [style.background]='sharedService.configForm.newsBannerTextColor || "black"'></div>
              <button class="card-button" mat-flat-button color="primary" (click)="showModal('textColor', 'Couleur du texte de la bannière')">
                {{'changeColor' | translation}}
              </button>
            </div>

            <div>

              <p class="card-title">{{ 'newsBannerBackgroundColor' | translation}}</p>
              <p class="card-subtitle"></p>
              <div class="color-thumb" [style.background]='sharedService.configForm.newsBannerBackgroundColor || "black"'></div>
              <button class="card-button" mat-flat-button color="primary" (click)="showModal('backgroundColor', 'Couleur d\'arrière-plan de la bannière')">
                {{'changeColor' | translation}}
              </button>
            </div>

            <div>
              <p class="card-title">{{'newsBannerText' | translation}}</p>

              <p class="card-data">{{sharedService.configForm.newsBannerText}}</p>
              <button class="card-button" mat-flat-button color="primary" (click)="showModal('newsBannerText')">
                {{'changeText' | translation}}
              </button>


            </div>

          </section>
        </ng-container>





        <div class="divider"> </div>

        <section *ngIf="mediaActive || lotteryActive || wayfindingActive" class="card-section">
          <p class="card-title">{{'activateDate' | translation}}</p>
          <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
          <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.activeDate" (ngModelChange)="changeValue()">
          </mat-slide-toggle>
          <!-- <mat-divider [inset]="true"></mat-divider> -->
        </section>
        <section *ngIf="mediaActive || lotteryActive || wayfindingActive" class="card-section" fxLayout="row" fxLayoutAlign="space-between center">

          <div>
            <p class="card-title">{{'activateWeather' | translation}}</p>
            <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
            <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.activeWeather" (ngModelChange)="changeValue()">
            </mat-slide-toggle>
          </div>
          <div fxLayout="column" *ngIf="sharedService.configForm.activeWeather && sharedService.configForm.selectedCity">
            <p class="card-title">{{'selectCity' | translation}}</p>

            <form class="citySelect">
              <mat-form-field class="citySelect-full-width" appearance="fill">
                <mat-label>{{'city' | translation}}</mat-label>
                <input type="text"
                       attr.placeholder="{{'choose' | translation}}"
                       attr.aria-label="{{'city' | translation}}"
                       matInput
                       [formControl]="citySelectControl"
                       [matAutocomplete]="auto" [(ngModel)]="sharedService.configForm.selectedCity.name">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedCity($event.option.value)">
                  <mat-option *ngFor="let option of filteredOptions | async | slice : 0 : 100" [value]="option.name">
                    {{option.name}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </form>


            <!-- <p class="card-data">Une seule participation par utilisateur</p>-->

          </div>
          <!-- <mat-divider [inset]="true"></mat-divider> -->
        </section>
        <!-- <section *ngIf="mediaActive" class="card-section">
        <p class="card-title">Activer la météo</p>
        <!-- <p class="card-data">Une seule participation par utilisateur</p>
              <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.activeWeather" (ngModelChange)="changeValue()">
              </mat-slide-toggle>



              <!-- <mat-divider [inset]="true"></mat-divider>
        </section>-->

      </section>

      <div class="divider"> </div>

      <section class="card-section">
        <p class="card-title">{{'textColor' | translation}}</p>



        <p class="card-subtitle"></p>



        <!-- <p class="card-data">{{ sharedService.configForm.inactivity}} secondes</p> -->

        <div class="color-thumb" [style.background]='sharedService.configForm.colorText'></div>
        <button class="card-button" mat-flat-button color="primary" (click)="showModal('textColor', 'Couleur d\'affichage du texte')">

          {{'changeColor' | translation}}
        </button>
        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>

      <section class="card-section">
        <p class="card-title">{{'buttonColor' | translation}}</p>
        <p class="card-subtitle"></p>

        <div class="color-thumb" [style.background]='sharedService.configForm.colorButton'></div>
        <button class="card-button" mat-flat-button color="primary" (click)="showModal('buttonColor')">
          {{'changeColor' | translation}}
        </button>
        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>

      <div class="divider"> </div>


      <section class="card-section">

        <p class="card-title">{{ 'inactivity' | translation }}</p>
        <p class="card-subtitle">{{ 'inactivityDescription' | translation}}</p>
        <p class="card-data">{{ sharedService.configForm.inactivity}} {{ 'seconds' | translation }}</p>

        <button class="card-button" mat-flat-button color="primary" (click)="showModal('sleepDelay')">
          {{'changeDelay' | translation}}
        </button>
        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>

      <div class="divider"> </div>



      <section class="card-section">
        <p class="card-title">{{'adminPassword' | translation}}</p>
        <p class="card-subtitle">{{'configDevice' | translation}}</p>
        <input matInput type="password" value="{{sharedService.configForm.password}}" class="card-data">

        <button class="card-button" mat-flat-button color="primary" (click)="showModal('password')">
          {{'changePassword' | translation}}
        </button>
        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>

      <div class="divider"> </div>


      <ng-container *ngIf="(sharedService.checkAppVersion('1.19.7', 'media') || sharedService.checkAppVersion('0.0.44', 'equinixWayfinding')) && sharedService.configForm.wakeUpSettings">

        <!--        ENABLE WAKEUP-->
        <section class="card-section">
          <p class="card-title">{{'wakeUpManager' | translation}}</p>
          <p class="card-subtitle">{{'wakeUpExplain' | translation}}</p>
          <div>
            <p class="card-title">{{'enableWakeup' | translation}}</p>
            <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="sharedService.configForm.wakeUpSettings.enable" (ngModelChange)="changeValue()">
            </mat-slide-toggle>
          </div>
          <div *ngIf="sharedService.configForm.wakeUpSettings.enable">

            <div class="timeContainer">
              <div class="startTime">
                <p>{{'startTime' | translation}}</p>
                <ngx-timepicker-field [format]="24" [(ngModel)]="sharedService.configForm?.wakeUpSettings.start" (ngModelChange)="changeValue()"></ngx-timepicker-field>
              </div>
              <div class="endTime">
                <p>{{'endTime' | translation}}</p>
                <ngx-timepicker-field [format]="24" [(ngModel)]="sharedService.configForm?.wakeUpSettings.end" (ngModelChange)="changeValue()"></ngx-timepicker-field>
              </div>
            </div>
            <div class="daysContainer">
              <div class="day" *ngFor="let day of days">

                <mat-slide-toggle color="accent" [(ngModel)]="day.enable" type="checkbox" (change)="changeValueDay(day)">
                  {{day.name}}
                </mat-slide-toggle>
              </div>

            </div>
          </div>
        </section>

        <div class="divider"> </div>

      </ng-container>
      <!-- <mat-form-field class="form-group" autocomplete="off">
        <input autocomplete="new-password" placeholder="Mot de passe administrateur" matInput  type="password" [(ngModel)]="configForm.password" class="form-control" id="password" name="password">
      </mat-form-field> -->



    </div>

  </section>

</main>
